import useCallApi from '../../utilities/axios'
import { encryption } from '../../utilities/encryption'
import * as umServiceURL from './umServiceURL'

export type ConnectLineType = {
    username: string
    password: string
    salt: string
    lineID: string
}
const useLineLogin = () => {
    const callApi = useCallApi()

    const postLineLogin = async (value: ConnectLineType) => {
        const { data } = await callApi.axiosPost<any>({
            url: umServiceURL.postLineLogin,
            params: { ...value },
        })

        return data
    }

    return { postLineLogin }
}

export default useLineLogin
